import { render } from "./editLabtest.vue?vue&type=template&id=35623a46&scoped=true"
import script from "./editLabtest.js?vue&type=script&lang=js"
export * from "./editLabtest.js?vue&type=script&lang=js"

import "./editLabtest.vue?vue&type=style&index=0&id=35623a46&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35623a46"]])

export default __exports__